// Copyright (c) 2016 Deere & Company

import Modal, {getDefaultState as getModalDefaultState} from '../../../product/shared/state/modal';
import t from 'tcomb';

const Preferences = t.struct({
    busyCounter: t.Number,
    confirmSaveModal: Modal,
    currentLanguageKey: t.String,
    isSaved: t.Boolean,
    nextLocation: t.String
}, 'Preferences');

export const getDefaultState = () =>
    new Preferences({
        busyCounter: 0,
        confirmSaveModal: getModalDefaultState(),
        currentLanguageKey: '',
        isSaved: true,
        nextLocation: ''
    });

export default Preferences;



// WEBPACK FOOTER //
// ./src/user/shared/state/preferences.js